// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.results-page {
    max-width: 600px;
    margin: 0 auto;
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .user-info, .exam-info {
    text-align: center;
    margin-bottom: 20px;
    padding: 10px;
    background-color: #f0f0f0;
    border-radius: 5px;
  }
  
  .results-breakdown {
    background-color: white;
    border: 1px solid #e0e0e0;
    border-radius: 5px;
    padding: 15px;
    margin-bottom: 20px;
  }
  
  .result-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid #eee;
  }
  
  .result-item:last-child {
    border-bottom: none;
  }
  
  .overall-result {
    background-color: #f4f4f4;
    padding: 15px;
    border-radius: 5px;
    margin-bottom: 20px;
    text-align: center;
  }
  
  .score-summary {
    display: flex;
    justify-content: space-around;
  }
  
  .results-actions {
    display: flex;
    justify-content: center;
    gap: 15px;
  }
  
  .button {
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .primary-button {
    background-color: #007bff;
    color: white;
  }
  
  .secondary-button {
    background-color: #6c757d;
    color: white;
  }
  
  .error-container {
    text-align: center;
    padding: 20px;
    background-color: #f8d7da;
    border-radius: 5px;
  }`, "",{"version":3,"sources":["webpack://./src/Pages/Exams/ExamResults.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;EACpB","sourcesContent":[".results-page {\r\n    max-width: 600px;\r\n    margin: 0 auto;\r\n    padding: 20px;\r\n    background-color: #f9f9f9;\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .user-info, .exam-info {\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n    padding: 10px;\r\n    background-color: #f0f0f0;\r\n    border-radius: 5px;\r\n  }\r\n  \r\n  .results-breakdown {\r\n    background-color: white;\r\n    border: 1px solid #e0e0e0;\r\n    border-radius: 5px;\r\n    padding: 15px;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .result-item {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 10px;\r\n    border-bottom: 1px solid #eee;\r\n  }\r\n  \r\n  .result-item:last-child {\r\n    border-bottom: none;\r\n  }\r\n  \r\n  .overall-result {\r\n    background-color: #f4f4f4;\r\n    padding: 15px;\r\n    border-radius: 5px;\r\n    margin-bottom: 20px;\r\n    text-align: center;\r\n  }\r\n  \r\n  .score-summary {\r\n    display: flex;\r\n    justify-content: space-around;\r\n  }\r\n  \r\n  .results-actions {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 15px;\r\n  }\r\n  \r\n  .button {\r\n    padding: 10px 20px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  .primary-button {\r\n    background-color: #007bff;\r\n    color: white;\r\n  }\r\n  \r\n  .secondary-button {\r\n    background-color: #6c757d;\r\n    color: white;\r\n  }\r\n  \r\n  .error-container {\r\n    text-align: center;\r\n    padding: 20px;\r\n    background-color: #f8d7da;\r\n    border-radius: 5px;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
